import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { connect } from "react-redux";
import RightBox from "./RightBox.js";
import Users from "./Users.js";
import UsersMap from "./UsersMap.js";
import UsersPass from "./UsersPass.js";
import Blog from "./Blog.js";
import ChangeInformation from "./ChangeInformation.js";
import Forms from "./Forms.js";
import Pics from "./Pics.js";
import Systems from "./Systems.js";
import SetSale from "./SetSale.js";
import SetNotification from "./SetNotification.js";
import Create_Off from "./Create_Off.js";
import Create_Filter from "./Create_Filter.js";
import Create_Form from "./Create_Form.js";
import Create_Fields from "./Create_Fields.js";
import Create_Reserve from "./Create_Reserve.js";
import Chat from "./Chat.js";
import TitlesMap from "./TitlesMap.js";
import Wallets from "./Wallets.js";
import Score_List from "./Score_List.js";
import Off_List from "./Off_List.js";
import Unit_List from "./Unit_List.js";
import Travel_Group from "./Travel_Group.js";
import Dashboards from "./Dashboard/Dashboards.js";
import Hotels from "./Hotels.js";
import Travel_Set from "./Travel_Set.js";
import CreateQuestions from "./Create_Questions.js";
import CreatePoll from "./Create_Poll.js";
import CustomerPoll from "./CustomerPoll.js";
import ShowPoll from "./ShowPoll.js";
import Create_Reports from "./Create_Reports.js";
import Show_Reports from "./Show_Reports.js";
import Codes_Files from "./Codes_Files.js";
import Company_Actions from "./Company_Actions.js";
import Company_Request from "./Company_Request.js";
import Ansar_Pic from "./Ansar_Pic.js";
import Edit_User_Credit from "./Edit_User_Credit.js";
import Edit_User_Credit_Price from "./Edit_User_Credit_Price.js";
import Del_Record from "./Del_Record.js";
import SendSms from "./SendSms.js";
import MehrCartRaymand from "./MehrCartRaymand.js";
import ManageShortLinks from "./ManageShortLinks.js";
import CreateFlight from "./CreateFlight.js";
import Inquiry from "./Inquiry.js";
import TurnRating from "./TurnRating.js";
import SettingsRate from "./SettingsRate.js";
import Forms_Details from "./Forms_Details.js";
import ReserveReqs from "./ReserveReqs.js";
import FirstPageLayout from "./FirstPageLayout.js";
import TransferReqs from "./TransferReqs.js";
import Set from "./Set.js";
import ShopInformation from "./ShopInformation.js";
import ShopsList from "./ShopsList.js";
import Server from "./../Server.js";
import MehrCartClear from "./MehrCartClear.js";
import AutoCredit from "./AutoCredit.js";
import LaonReq from "./LaonReq.js";
import AccReq from "./AccReq.js";
import ShopGroups from "./ShopGroups.js";
import TalaVam from "./TalaVam.js";
import SekeVam from "./SekeVam.js";
import SessionList from "./SessionList.js";
import SetDeposit from "./SetDeposit.js";
import TravelRobot from "./TravelRobot.js";
import TravelRobot_UserList from "./TravelRobot_UserList.js";
import Chat_Settings from "./Chat_Settings.js";
import PaykList from "./PaykList.js";
import "./RightBox.css";
import { Dialog } from "primereact/dialog";
import { Tabs, Popover } from "antd";
import { Breadcrumb, Select, Avatar, Layout, theme } from "antd";
import {
  SettingOutlined,
  BellOutlined,
  LogoutOutlined,
} from "@ant-design/icons";

const { Content, Sider, Header } = Layout;

function Management(props) {
  const [oldComponents, setOldComponents] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorDetial, setErrorDetial] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [profile, setProfile] = useState(null);
  const [systems, setSystems] = useState(null);
  const [userId, setUserId] = useState(null);
  const [systemLogo, setSystemLogo] = useState(null);
  const [systemName, setSystemName] = useState("");

  const [name, setName] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [broadcrumb, setBroadcrumb] = useState([]);
  const [collapse, setCollapse] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    setLoading(true);
    let SCallBack = (response) => {
      GetMaps(response.data.authData.map, response.data.authData.userId);
      getAllSystemOfUser(response.data.authData.userId);
      getUserInformation();
    };
    let ECallBack = (error) => {
      setLoading(false);
      console.log(error);
    };
    new Server().send("MainApi/checktoken", param, SCallBack, ECallBack);
    if (window.innerWidth <= 768) setIsMobile(true);
  }, []);

  const logout = (e) => {
    let SCallBack = function (response) {
      localStorage.setItem("api_token", "");
      navigate("/");
    };
    let ECallBack = function (error) {};
    new Server().send("MainApi/logout", {}, SCallBack, ECallBack);
  };

  const getUserInformation = () => {
    const server = new Server();
    let param = {
      token: localStorage.getItem("api_token"),
    };
    let SCallBack = (response1) => {
      const resp = response1.data.authData;
      const selectedSystem = props.systemId || localStorage.getItem("systemId");
      const profile = resp.profile
        ? server.getAbsoluteUrl() + resp.profile.split("public")[1]
        : null;
      setName(resp.name || resp.username);
      setSelectedSystem(selectedSystem);
      setProfile(profile);
      /*props.dispatch({
      type: "LoginTrueUser",
      systemId: selectedSystem,
    });*/
    };
    let ECallBack = (error) => {
      // that.setState({
      //   logout: true,
      // });
    };
    server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  };

  const GetMaps = (map, userId) => {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      user_Id: userId,
      systemId: props.systemId || localStorage.getItem("systemId"),
      sameUser: 1,
    };
    let SCallBack = function (response) {
      setLoading(false);
      if (!map || response.data.result.length == 0) {
        setErrorDetial("شما دسترسی به پنل مدیریت ندارید");
        setError("عدم دسترسی");
      } else {
        const CId =
          response.data.result.length > 0 && response.data.result[0].firstForm
            ? response.data.result[0].firstForm
            : "100";
        getFirstComponent(CId);
      }
    };
    let ECallBack = function (error) {
      console.log(error);
    };
    new Server().send("AdminApi/GetMaps", param, SCallBack, ECallBack);
  };

  const getFirstComponent = (CId) => {
    let param = {
      token: localStorage.getItem("api_token"),
      CId: CId,
    };
    setLoading(true);
    let SCallBack = function (response) {
      setLoading(false);
      const ress = response.data.result[0];
      const firstComponent = [
        {
          CId: ress.CId,
          IsReport: ress.IsReport,
          help: ress.help,
          label: ress.FName,
          permitions: ress.permitions || [],
        },
      ];
      getResponse({ oldComponents: firstComponent });
    };
    let ECallBack = function (error) {
      setLoading(false);
      console.log(error);
    };
    new Server().send("MainApi/getComponentInfo", param, SCallBack, ECallBack);
  };

  const getAllSystemOfUser = (userId) => {
    let param = {
      token: localStorage.getItem("api_token"),
      userId: userId,
    };
    setLoading(true);
    let SCallBack = function (response) {
      const ress = response.data.result;
      const systems = [];
      ress.map((item) => {
        systems.push({
          value: item.systemId,
          label: item.system[0]?.name,
        });
        if (item.system[0]._id === (props.systemId || localStorage.getItem("systemId"))) {
          if (item.system[0].logo) setSystemLogo(item.system[0].logo);
          setSystemName(item.system[0].name);
        }
      });
      setSystems(systems);
    };
    let ECallBack = function (error) {
      setLoading(false);
      console.log(error);
    };
    new Server().send(
      "AdminApi/getAllSystemOfUser",
      param,
      SCallBack,
      ECallBack
    );
  };

  const getResponse = (value) => {
    let oldComponents = [];
    if (value) {
      for (let i = 0; i < value.oldComponents.length; i++) {
        oldComponents.push(value.oldComponents[i]);
      }
      setOldComponents(oldComponents);
      setActiveIndex(oldComponents.length - 1);
      let itemsOfComponents = [];
      {
        oldComponents.map((item, index) => {
          itemsOfComponents.push({
            key: index,
            label: item.label,
            children: children(item),
            broadCrumb: item.parentLabel
              ? [
                  {
                    title: item.parentLabel,
                  },
                  {
                    title: item.label,
                  },
                ]
              : [
                  {
                    title: item.label,
                  },
                ],
          });
        });
      }
      setItems(itemsOfComponents);
      const current = itemsOfComponents[itemsOfComponents.length - 1];
      setBroadcrumb(current.broadCrumb);
    }
  };

  const children = (item) => {
    let component;
    {
      item.CId == "101" &&
        !item.IsReport &&
        (component = <Users permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "103" &&
        !item.IsReport &&
        (component = <Set permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "109" &&
        !item.IsReport &&
        (component = (
          <ChangeInformation permition={item.permitions[item.CId]} />
        ));
    }
    {
      item.CId == "151" &&
        !item.IsReport &&
        (component = <Codes_Files permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "154" &&
        !item.IsReport &&
        (component = <Company_Actions permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "155" &&
        !item.IsReport &&
        (component = <Company_Request permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "170" &&
        !item.IsReport &&
        (component = <Forms_Details permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "180" &&
        !item.IsReport &&
        (component = <Unit_List permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "183" &&
        !item.IsReport &&
        (component = <Chat permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "184" &&
        !item.IsReport &&
        (component = <Chat_Settings permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "193" &&
        !item.IsReport &&
        (component = <Systems permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "196" &&
        !item.IsReport &&
        (component = <SetNotification permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "204" &&
        !item.IsReport &&
        (component = <UsersPass permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "209" &&
        !item.IsReport &&
        (component = <SessionList permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "126" &&
        !item.IsReport &&
        (component = <Create_Filter permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "108" &&
        !item.IsReport &&
        (component = <Forms permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "197" &&
        !item.IsReport &&
        (component = <CreateQuestions permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "198" &&
        !item.IsReport &&
        (component = <CreatePoll permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "199" &&
        !item.IsReport &&
        (component = <CustomerPoll permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "127" &&
        !item.IsReport &&
        (component = <Create_Reports permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "165" &&
        !item.IsReport &&
        (component = <Create_Fields permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "164" &&
        !item.IsReport &&
        (component = <Create_Form permition={item.permitions[item.CId]} />);
    }

    {
      item.CId == "116" &&
        !item.IsReport &&
        (component = <Blog permition={item.permitions[item.CId]} />);
    }

    {
      item.CId == "115" &&
        !item.IsReport &&
        (component = <Pics permition={item.permitions[item.CId]} />);
    }

    {
      item.CId == "110" &&
        !item.IsReport &&
        (component = <ShopInformation permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "111" &&
        !item.IsReport &&
        (component = <ShopsList permition={item.permitions[item.CId]} />);
    }

    {
      item.CId == "158" &&
        !item.IsReport &&
        (component = <Create_Off permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "161" &&
        !item.IsReport &&
        (component = <Ansar_Pic permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "162" &&
        !item.IsReport &&
        (component = (
          <Edit_User_Credit permition={item.permitions[item.CId]} />
        ));
    }

    {
      item.CId == "166" &&
        !item.IsReport &&
        (component = <Create_Reserve permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "171" &&
        !item.IsReport &&
        (component = <ReserveReqs permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "172" &&
        !item.IsReport &&
        (component = <MehrCartClear permition={item.permitions[item.CId]} />);
    }

    {
      item.CId == "173" &&
        !item.IsReport &&
        (component = <AutoCredit permition={item.permitions[item.CId]} />);
    }

    {
      item.CId == "174" &&
        !item.IsReport &&
        (component = <LaonReq permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "175" &&
        !item.IsReport &&
        (component = <AccReq permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "176" &&
        !item.IsReport &&
        (component = <TitlesMap permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "177" &&
        !item.IsReport &&
        (component = <Wallets permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "178" &&
        !item.IsReport &&
        (component = <Score_List permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "179" &&
        !item.IsReport &&
        (component = <Off_List permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "181" &&
        !item.IsReport &&
        (component = <ShopGroups permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "185" &&
        !item.IsReport &&
        (component = <FirstPageLayout permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "188" &&
        !item.IsReport &&
        (component = <TransferReqs permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "189" &&
        !item.IsReport &&
        (component = <TalaVam permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "190" &&
        !item.IsReport &&
        (component = <SekeVam permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "195" &&
        !item.IsReport &&
        (component = <SetSale permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "200" &&
        !item.IsReport &&
        (component = <ShowPoll permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "201" &&
        !item.IsReport &&
        (component = (
          <Edit_User_Credit_Price permition={item.permitions[item.CId]} />
        ));
    }
    {
      item.CId == "202" &&
        !item.IsReport &&
        (component = <Del_Record permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "203" &&
        !item.IsReport &&
        (component = <SendSms permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "204" &&
        !item.IsReport &&
        (component = <UsersPass permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "205" &&
        !item.IsReport &&
        (component = <UsersMap permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "206" &&
        !item.IsReport &&
        (component = <Travel_Group permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "207" &&
        !item.IsReport &&
        (component = <Travel_Set permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "208" &&
        !item.IsReport &&
        (component = <Hotels permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "210" &&
        !item.IsReport &&
        (component = <SetDeposit permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "211" &&
        !item.IsReport &&
        (component = <TravelRobot permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "212" &&
        !item.IsReport &&
        (component = (
          <TravelRobot_UserList permition={item.permitions[item.CId]} />
        ));
    }
    {
      item.CId == "213" &&
        !item.IsReport &&
        (component = <MehrCartRaymand permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "215" &&
        !item.IsReport &&
        (component = (
          <ManageShortLinks permition={item.permitions[item.CId]} />
        ));
    }
    {
      item.CId == "216" &&
        !item.IsReport &&
        (component = <CreateFlight permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "217" &&
        !item.IsReport &&
        (component = <TurnRating permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "218" &&
        !item.IsReport &&
        (component = <SettingsRate permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "219" &&
        !item.IsReport &&
        (component = <Dashboards permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "310" &&
        !item.IsReport &&
        (component = <Inquiry permition={item.permitions[item.CId]} />);
    }
    {
      item.CId == "220" &&
        !item.IsReport &&
        (component = <PaykList permition={item.permitions[item.CId]} />);
    }

    {
      item.IsReport && (component = <Show_Reports number={item.CId} />);
    }
    return component;
  };
  const {
    token: { colorBgContainer, colorFillSecondary },
  } = theme.useToken();

  return (
    <div style={{ height: "100%" }}>
      <Layout style={{ height: "100%" }} className="sarv-container">
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            background: colorFillSecondary,
            paddingRight: 15,
            paddingLeft: 15,
            direction: "rtl",
          }}
        >
          {!isMobile && (
            <div style={{ width: "calc(100% - 270px)", display: "flex" }}>
              <div style={{ display: "flex", alignItems: "baseline" }}>
                <div>
                  <img src={systemLogo} style={{ width: 40 }} />
                </div>
                <span
                  style={{
                    marginRight: 20,
                    fontWeight: "bold",
                    fontSize: "large",
                    fontFamily: "IRANYekan",
                  }}
                >
                  {systemName}
                </span>
              </div>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minWidth: 270,
            }}
          >
            <Popover
              content={
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    fontFamily: "iranyekanweblight",
                  }}
                >
                  <li style={{ color: "red" }}>
                    <a
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        logout();
                      }}
                    >
                      <LogoutOutlined style={{ paddingLeft: 10 }} />
                      <span>خروج</span>
                    </a>
                  </li>
                </ul>
              }
              title={name}
              trigger="click"
              onOpenChange={() => {}}
            >
              <Avatar icon={<img src={profile} />} />
            </Popover>
            <SettingOutlined />
            <BellOutlined />
            {selectedSystem && systems && systems.length > 1 && (
              <div className="mt-lg-1" style={{ direction: "ltr" }}>
                <Select
                  defaultValue={
                    systems.filter((item) => {
                      return item.value === selectedSystem;
                    })[0].label
                  }
                  style={{ fontFamily: "IranYekan", width: 100 }}
                  options={systems}
                  onChange={(value) => {
                    localStorage.setItem("systemId", value);
                    setSelectedSystem(value);
                    window.location.reload();
                  }}
                ></Select>
              </div>
            )}
          </div>
        </Header>
        <Layout style={{ height: "100%" }}>
          {selectedSystem && (
            <Sider
              style={{ background: colorBgContainer, overflowY: "auto" }}
              collapsible={!isMobile}
              collapsed={collapse || isMobile}
              reverseArrow={true}
              onCollapse={(value) => setCollapse(value)}
            >
              <RightBox
                oldComponents={oldComponents}
                selectedSystem={selectedSystem}
                callback={(oldComponents) => {
                  getResponse(oldComponents);
                }}
              />
            </Sider>
          )}
          <Layout style={{ height: "100%" /*,overflow:'auto'*/ }}>
            {error ? (
              <div
                style={{ marginTop: 150, textAlign: "center", width: "100%" }}
              >
                <h2>{error}</h2>
                <h3 className="mt-5">{errorDetial}</h3>
              </div>
            ) : (
              <div style={{ width: "100%", height: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingRight: 18,
                    paddingTop: 10,
                  }}
                >
                  <div>
                    <Breadcrumb items={broadcrumb} />
                  </div>
                </div>
                <Content style={{ height: "100%" }}>
                  <Tabs
                    tabPosition="top"
                    type="editable-card"
                    hideAdd={true}
                    addIcon={false}
                    defaultActiveKey={activeIndex}
                    activeKey={activeIndex}
                    onChange={(e) => {
                      console.log(items);
                      const value = parseInt(e);
                      const currentItem = items.filter(
                        (item) => item.key === value
                      )[0];
                      if (value != activeIndex) {
                        setActiveIndex(value);
                        setBroadcrumb(currentItem.broadCrumb);
                      }
                    }}
                    onEdit={(targetKey) => {
                      if (targetKey === 0) return;
                      let newActiveKey = activeIndex;
                      let lastIndex = -1;
                      items.forEach((item, i) => {
                        if (item.key === targetKey) {
                          lastIndex = i - 1;
                        }
                      });
                      const newPanes = items.filter(
                        (item) => item.key !== targetKey
                      );
                      if (newPanes.length && newActiveKey === targetKey) {
                        if (lastIndex >= 0) {
                          newActiveKey = newPanes[lastIndex].key;
                        } else {
                          newActiveKey = newPanes[0].key;
                        }
                      }
                      oldComponents.splice(targetKey, 1);
                      setOldComponents(oldComponents);
                      setItems(newPanes);
                      setActiveIndex(newActiveKey);
                    }}
                    items={items}
                  />
                </Content>
              </div>
            )}
          </Layout>
        </Layout>
      </Layout>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Management);
